// Styles for the map container used for selecting a station
import baseStyles from 'catena/er2_styles'
import * as colors from './colors'

export const styles = {
    buttonPrimary: {
        borderColor: colors.primaryOne,
        borderRadius: '5px',
        borderWidth: '3px',
        color: 'black',
        backgroundColor: 'lightgray',
        padding: '10px',
        width: '100%',
        '&:hover': {
            backgroundColor: 'default',
        },
    },
    collaboration: {
        gridColumnEnd: 'main',
        gridColumnStart: 'controlBar',
        gridRowEnd: 'bottom',
        gridRowStart: 'main',
    },
    collaborationLabel: {
        display: 'inline-block',
        width: '200px',
    },
    section: {
        paddingBottom: '10px',
        paddingLeft: '10px',
        paddingRight: '10px',
        paddingTop: '10px',
    },
    sessionNameInput: Object.assign({}, baseStyles.input, {
        width: '260px',
    }),
    styleLabelPlusToggle: {
        width: '266px',
    },
}

export default styles
